import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { 
  Box, 
  Typography, 
  Rating, 
  Paper,
  Container,
  IconButton,
  Button,
  Fade
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SendIcon from '@mui/icons-material/Send';
import {
  addfeedbackDispatch,
  getCustomerIdDispatch,
} from '../reducers/HomeReducer';
import './DropZoneFeedback.css';

const ReviewForm = () => {
  const { id, name } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cust } = useSelector((state) => state.home);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(getCustomerIdDispatch(id));
    }
  }, [dispatch, id]);

  // Check if user status is inactive
  const isUserInactive = cust?.result?.status !== 'active' && cust?.result?.status !== undefined;

  const validationSchema = Yup.object({
    contact: Yup.string()
      .matches(/^\d{10}$/, 'Enter a valid phone number')
      .required('Phone number is required'),
    email: Yup.string()
      .email('Invalid email format'),
    review: Yup.string()
      .max(500, 'Review must be less than 500 characters')
      .required('Review is required'),
  });

  const handleSubmit = (values, { resetForm }) => {
    const form = {
      name: values.name,
      phone: values.contact,
      email: values.email,
      cust_id: id,
      api_key: cust?.result?.apikey,
      desc: values.review,
      rating: values.rating
    };
    
    dispatch(addfeedbackDispatch(form));
    setSubmitted(true);
    resetForm();
  };

  const handleRatingChange = (rating) => {
    if (rating > 3) {
      
        navigate(`/gen-review/${id}/${name}`);
        // window.location.href = cust.result.url;
      
    }
  };

  // In your success screen:
// Inactive user section
if (isUserInactive) {
  return (
    <Container maxWidth="sm" className="feedback-container">
      <Paper className="container1" elevation={3} sx={{ background: 'linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)' }}>
        <Box sx={{ padding: '40px 20px', textAlign: 'center' }}>
          {/* Inactive Icon */}
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              background: '#ffebee',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(211, 47, 47, 0.15)'
            }}>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="60" 
                height="60" 
                viewBox="0 0 24 24" 
                fill="none"
                stroke="#d32f2f"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M15 9l-6 6M9 9l6 6" />
              </svg>
            </Box>
          </Box>

          {/* Heading */}
          <Typography variant="h4" gutterBottom sx={{ 
            color: '#d32f2f', 
            fontWeight: 'bold', 
            mb: 1
          }}>
            Account Inactive
          </Typography>

          {/* Main Message */}
          <Typography variant="body1" sx={{ 
            textAlign: 'center', 
            mb: 2, 
            color: '#555',
            lineHeight: 1.6,
            fontSize: '16px'
          }}>
            Your account is currently inactive. You don't have access to submit feedback or use this service at the moment.
          </Typography>

          {/* Support Message */}
          <Typography variant="body2" sx={{ 
            textAlign: 'center', 
            color: '#888', 
            mb: 4,
            fontSize: '14px'
          }}>
            Don't worry! Contact our support team to reactivate your account.
          </Typography>

         

          {/* Contact Info */}
          {/* <Box sx={{
            background: 'rgba(255,255,255,0.7)',
            border: '1px solid #f5c6c6',
            borderRadius: '8px',
            padding: '16px',
            mb: 2
          }}>
            <Typography variant="caption" sx={{ color: '#666', display: 'block', mb: 1 }}>
              📞 {cust?.result?.mobile}
            </Typography>
            <Typography variant="caption" sx={{ color: '#666', display: 'block' }}>
              📧 {cust?.result?.email}
            </Typography>
          </Box> */}

          {/* CTA Button */}
          {/* <Button 
            variant="contained" 
            fullWidth
            sx={{
              backgroundColor: '#d32f2f',
              color: 'white',
              padding: '12px',
              fontSize: '16px',
              fontWeight: '600',
              '&:hover': {
                backgroundColor: '#b71c1c'
              }
            }}
            onClick={() => window.location.href = `mailto:${cust?.result?.email}?subject=Account Activation Request`}
          >
            Request Account Activation
          </Button> */}
        </Box>
      </Paper>
    </Container>
  );
}

if (submitted) {
  return (
    <Container maxWidth="sm" className="feedback-container">
      <Paper className="container thank-you" elevation={3}>
        <Box className="success-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="64" 
            height="64" 
            viewBox="0 0 24 24" 
            fill="#4caf50"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </Box>
        <Typography variant="h5" gutterBottom>
          Thank You!
        </Typography>
        <Typography variant="body1">
          Your feedback has been submitted successfully. We appreciate your time!
        </Typography>
        <Button 
          variant="contained" 
          color="primary"
          onClick={() => setSubmitted(false)}
          sx={{ mt: 3 }}
        >
          Submit Another Feedback
        </Button>
      </Paper>
    </Container>
  );
}


  return (
    <Container maxWidth="sm" className="feedback-container">
      <Paper className="container1" elevation={3}>
        <Box className="header1">
				<Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 4,
  }}
>
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: '12px' }}
  >
    <path
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      fill="#FFC107"
      stroke="#FF9800"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  <Typography
    variant="h4"
    sx={{
      color: "#000",
      textAlign: "center",
      fontWeight: "bold",
    }}
  >
    {cust?.result?.agency_name || "Agency"}
  </Typography>
</Box>



          
        </Box>

        <Box className="contact-icons">
          <IconButton className="icon-circle phone-icon" aria-label="call">
            <Link to={`tel:${cust?.result?.mobile}`}><PhoneIcon /></Link>
          </IconButton>
          <IconButton className="icon-circle email-icon" aria-label="email">
					<Link to={`mailto:${cust?.result?.email}`}><EmailIcon /></Link>
          </IconButton>
          <IconButton className="icon-circle whatsapp-icon" aria-label="whatsapp">
					<Link to={`https://wa.me/+91${cust?.result?.mobile}`}>
						<WhatsAppIcon />
					</Link>
          </IconButton>
        </Box>

        <Typography variant="h6" className="title">
          We Value Your Feedback
        </Typography>
        <Typography variant="body2" className="subtitle">
          Please rate your experience with our service
        </Typography>

        <Formik
          initialValues={{
            rating: 0,
            name: '',
            contact: '',
            email: '',
            review: ''
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isValid, dirty }) => (
            <Form>
              <Box className="rating-container">
                <Typography className="rating-label">How would you rate us?</Typography>
                <div className="star-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      className={`star ${values.rating >= star ? 'filled' : ''}`}
                      onClick={() => {
                        setFieldValue('rating', star);
                        handleRatingChange(star);
                      }}
                    >
                      ★
                    </span>
                  ))}
                </div>
              </Box>

              {values.rating > 0 && values.rating <= 3 && (
                <Fade in={true}>
                  <Box className="form-container">
                    <div className="form-group">
                      <label htmlFor="name">Your Name<span className="required">*</span></label>
                      <Field
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                      />
                      <ErrorMessage name="name" component="div" className="error" />
                    </div>

                    <div className="form-group">
                      <label htmlFor="contact">Phone Number<span className="required">*</span></label>
                      <Field
                        type="text"
                        id="contact"
                        name="contact"
                        placeholder="Enter your phone number"
                      />
                      <ErrorMessage name="contact" component="div" className="error" />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <Field
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                      />
                      <ErrorMessage name="email" component="div" className="error" />
                    </div>

                    <div className="form-group">
                      <label htmlFor="review">Your Feedback<span className="required">*</span></label>
                      <Field
                        as="textarea"
                        id="review"
                        name="review"
                        placeholder="Share your experience..."
                        rows="4"
                      />
                      <ErrorMessage name="review" component="div" className="error" />
                    </div>

                    <Button 
                      type="submit" 
                      variant="contained" 
                      color="primary" 
                      endIcon={<SendIcon />}
                      fullWidth
                      size="large"
                      disabled={!(isValid && dirty)}
                      className="submit-btn"
                    >
                      Submit Feedback
                    </Button>
                  </Box>
                </Fade>
              )}
            </Form>
          )}
        </Formik>
      </Paper>
    </Container>
  );
};

export default ReviewForm;
